import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { ListOccurrencesQuery, OccurrenceList } from '@klopotun/contracts';
import { occurrenceQueries } from './occurrence-queries.js';

type OccurrencesQueryOptions = {
  /** Off, the listing is neither fetched nor kept fresh - for a screen that shows it on demand. */
  enabled?: boolean;
};

export const useOccurrencesQuery = (
  query?: ListOccurrencesQuery,
  options: OccurrencesQueryOptions = {},
): UseQueryResult<OccurrenceList> =>
  useQuery({ ...occurrenceQueries.list(query), enabled: options.enabled ?? true });
